/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Root_Error_Boundary_DescriptionInputs */

const en_components_root_error_boundary_description = /** @type {(inputs: Components_Root_Error_Boundary_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong while opening Glider. Reload the app to try again.`)
};

const de_components_root_error_boundary_description = /** @type {(inputs: Components_Root_Error_Boundary_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beim Öffnen von Glider ist etwas schiefgelaufen. Laden Sie die App neu, um es erneut zu versuchen.`)
};

const pt_br2_components_root_error_boundary_description = /** @type {(inputs: Components_Root_Error_Boundary_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo deu errado ao abrir o Glider. Recarregue o app para tentar novamente.`)
};

const tr_components_root_error_boundary_description = /** @type {(inputs: Components_Root_Error_Boundary_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider açılırken bir sorun oluştu. Uygulamayı yeniden yükleyip tekrar deneyin.`)
};

const zh_cn2_components_root_error_boundary_description = /** @type {(inputs: Components_Root_Error_Boundary_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开 Glider 时出了点问题。请重新加载应用后再试。`)
};

const zh_hk2_components_root_error_boundary_description = /** @type {(inputs: Components_Root_Error_Boundary_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開啟 Glider 時發生問題。請重新載入應用程式再試。`)
};

const ko_kr2_components_root_error_boundary_description = /** @type {(inputs: Components_Root_Error_Boundary_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider를 여는 중 문제가 발생했습니다. 앱을 새로고침하고 다시 시도하세요.`)
};

const ru_ru2_components_root_error_boundary_description = /** @type {(inputs: Components_Root_Error_Boundary_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`При открытии Glider что-то пошло не так. Перезагрузите приложение и попробуйте снова.`)
};

const es_419_components_root_error_boundary_description = /** @type {(inputs: Components_Root_Error_Boundary_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo salió mal al abrir Glider. Recarga la app para intentarlo de nuevo.`)
};

/**
* | output |
* | --- |
* | "Something went wrong while opening Glider. Reload the app to try again." |
*
* @param {Components_Root_Error_Boundary_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const components_root_error_boundary_description = /** @type {((inputs?: Components_Root_Error_Boundary_DescriptionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Root_Error_Boundary_DescriptionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_components_root_error_boundary_description(inputs)
	if (locale === "de") return de_components_root_error_boundary_description(inputs)
	if (locale === "pt-BR") return pt_br2_components_root_error_boundary_description(inputs)
	if (locale === "tr") return tr_components_root_error_boundary_description(inputs)
	if (locale === "zh-CN") return zh_cn2_components_root_error_boundary_description(inputs)
	if (locale === "zh-HK") return zh_hk2_components_root_error_boundary_description(inputs)
	if (locale === "ko-KR") return ko_kr2_components_root_error_boundary_description(inputs)
	if (locale === "ru-RU") return ru_ru2_components_root_error_boundary_description(inputs)
	return es_419_components_root_error_boundary_description(inputs)
});